import {
  OrderRulesUpdateRequestType,
  OrderRulesUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderRulesUpdate = (OrderRulesId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderRulesUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `order-rules/${OrderRulesId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as OrderRulesUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderRules, OrderRulesId],
      });
    },
  });
};
